<template>
    <div
        v-if="params"
        :style="styles"
        class="o-sorting-panel sorting-panel"
    >
        <span class="sorting-panel__label">
            {{ label }}
        </span>
        <div class="sorting-panel__wrapper">
            <button
                type="button"
                class="sorting-panel__button"
                :class="{'sorting-panel__button--active': localValue === 'All'}"
                @click="onClick('All')"
            >
                {{ allLabel }}
            </button>
            <button
                type="button"
                class="sorting-panel__button"
                :class="{'sorting-panel__button--active': button.value === localValue}"
                v-for="(button, index) in showDefinedButtons"
                :key="index"
                @click="onClick(button.value)"
            >
                {{ button.name }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
    
import { characters } from "./o-sorting-panel-characters";

export default {
    name: "OSortingPanel",
    props: {
        /**
         * Value for v-model
         */
        value: {
            type: String,
            default: ''
        },
        /**
         * Show defined buttons
         */
        definedButtons: {
            type: Array,
            default: () => []
        },
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getActiveLocale',
            'getMapConfigProp'
        ]),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e)
            }
        },
        getCharacters() {
            const theme = this.params?.theme || '';
            
            if (theme) {
                return characters[theme][this.getActiveLocale];
            }

            return characters[this.getActiveLocale];
        },
        showDefinedButtons() {
            const characters = this.getCharacters;
            const buttons = this.definedButtons;

            if (buttons.length) {
                return characters.reduce((acc, item) => {
                    let find;
                    for (let i = 0; i < item.value.length; i++) {
                        if(buttons.includes(item.value.charAt(i))) {
                            find = true
                            break;
                        }
                    }

                    if (find) acc.push(item);
                    return acc;
                }, []);
            }
            return characters;
        },
        commonStyles() {
            return this.getMapConfigProp('components.OSortingPanel.styles') || {};
        },
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OSortingPanel.styles`) || {};
        },
        styles() {
            return {
                ...this.commonStyles
                // TODO: uncomment before merge to dev
                // ...this.componentStyles
            }
        },
        params() {
            return {
                ...this.commonParams,
                ...this.componentParams
            }
        },
        commonParams() {
            return this.getMapConfigProp('components.OSortingPanel.params') || {};
        },
        componentParams() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OSortingPanel.params`) || null;
        },
        label() {
            return this.$t(this.params.label);
        },
        allLabel() {
            return this.$t(this.params.allLabel);
        }
    },
    methods: {
        onClick(evt) {
            this.localValue = this.value === evt ? 'All' : evt;
            this.$emit('onClick', evt);
        }
    }
}

</script>

<style lang="scss">
@import "o-sorting-panel";
</style>
